import { render } from "./UserPulseStats.vue?vue&type=template&id=0ebd3c1a&scoped=true"
import script from "./UserPulseStats.vue?vue&type=script&lang=js"
export * from "./UserPulseStats.vue?vue&type=script&lang=js"

import "./UserPulseStats.vue?vue&type=style&index=0&id=0ebd3c1a&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebd3c1a"]])

export default __exports__